import store from "@/store/index";
import multiguard from "vue-router-multiguard";
import tokenMiddleware from "@/middlewares/tokenMiddleware";

export default [
    {
        path: "welcome",
        meta: {
            layout: () => import("../layouts/OnboardingLayout"),
        },
        alias: ["sveiki"],
        component: () => import("../views/Onboarding/Onboarding.vue"),
        beforeEnter: multiguard([
            tokenMiddleware,
            async (to, from, next) => {
                const clientData = await store.dispatch("clientDataIndex");

                if (
                    clientData?.projects &&
                    clientData?.projects > 0
                ) {
                    next({
                        ...to,
                        name: "projects_index",
                    });
                }

                next();
            },
        ]),
        children: [
            {
                path: "",
                name: "welcome",
                component: () => import("../views/Onboarding/UserRole.vue"),
            },
            {
                path: "select-document",
                name: "onboarding_document_select",
                component: () =>
                    import("../views/Onboarding/Document/DocumentSelect.vue"),
            },
            {
                path: "create/cookie_consent_banner",
                name: "onboarding_ccb_create",
                meta: {
                    hideTitle: true,
                    noProfile: true,
                },
                component: () =>
                    import("../views/Onboarding/Document/OnboardingCookieConsentCreate.vue"),
            },
            {
                path: "create/:doc",
                name: "onboarding_document_create",
                meta: {
                    layout: "Generation",
                    hideTitle: true,
                    noProfile: true,
                    sideMenuComponent: () =>
                        import("@/components/DocumentGeneration/QuestionSteps.vue"),
                },
                component: () =>
                    import("../views/Onboarding/Document/OnboardingDocumentCreate.vue"),
            },
        ],
    },
    // {
    //     path: "first-document/:project_id",
    //     meta: {
    //         layout: () => import("../layouts/NoHeader"),
    //     },
    //     alias: ["pirmas-dokumentas/:project_id"],
    //     component: () => import("../views/Onboarding/Onboarding.vue"),
    //     children: [
    //         {
    //             path: "",
    //             name: "onboarding_document_select",
    //             meta: {
    //                 step: 5,
    //             },
    //             component: () =>
    //                 import("../views/Onboarding/Document/DocumentSelect.vue"),
    //         },
    //     ],
    // },
    // {
    //     path: "first-document/:project_id/cookie-consent",
    //     name: "onboarding_cookie_consent",
    //     meta: {
    //         layout: "Generation",
    //         hideTitle: true,
    //         noProfile: true,
    //         sideMenuComponent: false
    //     },
    //     component: () =>
    //         import("../views/Onboarding/Document/CookieConsentCreate.vue"),
    // },
    // {
    //     path: "first-document/:project_id/:doc",
    //     name: "onboarding_document_create",
    //     meta: {
    //         layout: "Generation",
    //         hideTitle: true,
    //         noProfile: true,
    //         sideMenuComponent: () =>
    //             import("@/components/DocumentGeneration/QuestionSteps.vue"),
    //     },
    //     component: () =>
    //         import("../views/Onboarding/Document/DocumentCreate.vue"),
    // },
    // {
    //     path: "welcome/upgrade",
    //     name: "onboarding_upgrade",
    //     meta: {
    //         layout: () => import("../layouts/NoHeader"),
    //     },
    //     alias: ["sveiki/rinktis-plana"],
    //     component: () => import("../views/Onboarding/Upgrade.vue"),
    // },
];
